import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, } from 'react-native';
import {
    JDImage, JDText
} from '@jdreact/jdreact-core-lib';
import {
    emptyIcon
  } from '../../../utils/image'
import { pt,  } from '../../../components/utiles';

export default class EmptyCard extends PureComponent {
    static defaultProps = {
        textOne: '',
        textTwo: ''
    }

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {

    }
    render() {
        const {
            textOne,
            textTwo
        } = this.props;
        return (
            <View style={st.banner_itemBox}>
                <View style={st.banner_itemiconBox}>
                    <JDImage style={[st.banner_itemicon]} source={emptyIcon} resizeMode='contain' />
                </View>
                <View style={[st.itemTextWrap1]}>
                    <JDText style={[st.itemTextStyle]}>{textOne}</JDText>
                </View>
                <View style={[st.itemTextWrap2]}>
                    <JDText style={[st.itemTextStyle]}>{textTwo}</JDText>
                </View>
            </View>
        );
    }
}

EmptyCard.propTypes = {
    itemTextStyle: PropTypes.object,
    bannerList: PropTypes.array,
    onBeforeJump: PropTypes.func
};
const st = StyleSheet.create({
    banner_itemBox: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    banner_itemiconBox: {
        width: pt(304),
        height: pt(304),
        marginBottom: pt(32)
    },
    banner_itemicon: {
        width: pt(304),
        height: pt(304),
    },
    itemTextWrap1: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    itemTextWrap2: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: pt(8)
    },
    itemTextStyle: {
        textAlign: 'center',
        fontSize: pt(30),
        color: '#cccccc'
    },
});
